module.exports = __webpack_public_path__ + "img/社招岗位@2x.dcc19909.png";